import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import arTranslations from '../locales/ar.json';
import enTranslations from '../locales/en.json';
import zhTranslations from '../locales/zh.json';
import hiTranslations from '../locales/hi.json';
import haTranslations from '../locales/ha.json';
import ruTranslations from '../locales/ru.json';
import esTranslations from '../locales/es.json';
import trTranslations from '../locales/tr.json';
import frTranslations from '../locales/fr.json';
import { DEFAULT_LANGUAGE } from '../utils/constants';

const resources = {
  ar: {
    translation: arTranslations,
  },
  en: {
    translation: enTranslations,
  },
  zh: {
    translation: zhTranslations,
  },
  hi: {
    translation: hiTranslations,
  },
  ha: {
    translation: haTranslations,
  },
  ru: {
    translation: ruTranslations,
  },
  es: {
    translation: esTranslations,
  },
  tr: {
    translation: trTranslations,
  },
  fr: {
    translation: frTranslations,
  },
};

void i18n
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    lng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      // Order of language detection
      order: [
        'localStorage',
        'navigator',
        'htmlTag',
        'path',
        'subdomain',
      ],
      // Keys to store language preference
      caches: ['localStorage'],
      // HTML lang attribute
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;

